// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1EG5Q","footer":"Form_footer__1X1_2"};